import React from 'react';
import links from '../MenuLinks';
import InternalMenu from '../InternalMenu';

function ContactMenu() {
  const contactLinks = links.find(linksCollection => linksCollection.menuName.indexOf('Contact Us') !== -1);
  return (
    <InternalMenu
      links={contactLinks.menuItems}
      menuName={contactLinks.menuName}
    />
  );
}

export default ContactMenu;



// WEBPACK FOOTER //
// ./src/components/menus/Contact.js